import React from 'react';
export function CircleCrossIllustration() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      fill: '#FA3E70'
    },
    "data-testid": "circle-cross-illustration",
    role: "img",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 5.05263C24.2809 5.05263 5.05263 24.2809 5.05263 48C5.05263 71.7191 24.2809 90.9474 48 90.9474C71.7191 90.9474 90.9474 71.7191 90.9474 48C90.9474 24.2809 71.7191 5.05263 48 5.05263ZM0 48C0 21.4904 21.4904 0 48 0C74.5096 0 96 21.4904 96 48C96 74.5096 74.5096 96 48 96C21.4904 96 0 74.5096 0 48ZM52.3652 48.5386L64.9968 61.1702L61.4241 64.7429L48.7925 52.1113L36.1609 64.7429L32.5882 61.1702L45.2198 48.5386L32.8421 36.1609L36.4148 32.5882L48.7925 44.9659L61.1702 32.5882L64.7429 36.1609L52.3652 48.5386Z"
  }));
}